import React from 'react';

import { SubComponentProps } from '../../interfaces';
import ResponsiveSubTable from './types/ResponsiveSubTable';
import SimpleText from './types/SimpleText';
import TableRequest from './types/TableRequest';

const SubComponent: React.FC<SubComponentProps> = ({
  data,
  type,
  cancelToken,
  style,
  clearCache,
  parentExpanded = false,
  level = '',
  expandHeight,
  tableView,
}) => {
  switch (type) {
    case 'simple_text':
      return (
        <SimpleText
          clearCache={clearCache}
          cancelToken={cancelToken}
          data={data}
          style={style}
        />
      );
    case 'responsive_table':
      return (
        <ResponsiveSubTable
          clearCache={clearCache}
          cancelToken={cancelToken}
          data={data}
        />
      );
    case 'responsive_table_request':
      return (
        <TableRequest
          cancelToken={cancelToken}
          data={data}
          parentExpanded={parentExpanded}
          level={level}
          expandHeight={expandHeight}
          tableView={tableView}
        />
      );
    // dynamic_columns_table_request
    default:
      return <></>;
  }
};

export default SubComponent;
